import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import './header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="header">
      <div className="logo">
        <Link to="/">D-BE</Link>
      </div>

      {/* Hamburger Menu for Mobile */}
      <div className={`menu-toggle ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </div>

      {/* Navigation Links */}
      <nav className={`nav ${isMenuOpen ? "open" : ""}`}>
        <ul>
          <li>
            <NavLink to="/" exact activeClassName="active">
              HOME
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" activeClassName="active">
              A PROPOS
            </NavLink>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
